var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7143 18.5C16.7143 15.8153 13.1965 13.6389 8.85714 13.6389C4.51776 13.6389 1 15.8153 1 18.5M8.85714 10.7222C6.14503 10.7222 3.94643 8.54583 3.94643 5.86111C3.94643 3.17639 6.14503 1 8.85714 1C11.5693 1 13.7679 3.17639 13.7679 5.86111C13.7679 8.54583 11.5693 10.7222 8.85714 10.7222Z",
    stroke: "#F8F8FA",
    strokeOpacity: 0.7,
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7143 18.5C16.7143 15.8153 13.1965 13.6389 8.85714 13.6389C4.51776 13.6389 1 15.8153 1 18.5M8.85714 10.7222C6.14503 10.7222 3.94643 8.54583 3.94643 5.86111C3.94643 3.17639 6.14503 1 8.85714 1C11.5693 1 13.7679 3.17639 13.7679 5.86111C13.7679 8.54583 11.5693 10.7222 8.85714 10.7222Z",
    stroke: "currentColor",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7143 10.3333H19.8572M19.8572 10.3333H23M19.8572 10.3333V7.22217M19.8572 10.3333V13.4444",
    stroke: "#F8F8FA",
    strokeOpacity: 0.7,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7143 10.3333H19.8572M19.8572 10.3333H23M19.8572 10.3333V7.22217M19.8572 10.3333V13.4444",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/addUser.8b80d8aa521a31cdaeea8103d98be950.svg";
export { ForwardRef as ReactComponent };